module.exports = __webpack_public_path__ + "img/800f.24e93dd8.png";